
import { ViewportPortal } from '@xyflow/react'
import { SIGNAL_CATEGORIES, SIGNAL_META, type SignalCategory } from '@/lib/signals'

/** The marker id a cable of this signal points its input end with. */
export function arrowMarkerId(signal: SignalCategory): string {
  return `cable-arrow-${signal.toLowerCase()}`
}

/**
 * One arrowhead per signal colour, defined inside the viewport so the
 * schematic export (which rasterises the viewport element) carries them too.
 *
 * The tip stops 7 px short of the endpoint: the endpoint is the centre of a
 * 10 px port handle with a 2 px rim, and an arrow buried under the dot says
 * nothing. Fills are the same variables as the cable strokes, so they follow
 * the theme and the export's light override alike.
 */
export function CableMarkers() {
  // viewBox 0–10, drawn at 9 px: one user px is 10/9 marker units, so pulling
  // the reference point 7 px past the tip is 10 + 7 × 10/9 ≈ 17.8.
  const refX = 10 + 7 * (10 / 9)
  return (
    <ViewportPortal>
      <svg width="0" height="0" aria-hidden="true" style={{ position: 'absolute', overflow: 'visible' }}>
        <defs>
          {SIGNAL_CATEGORIES.map((signal) => (
            <marker
              key={signal}
              id={arrowMarkerId(signal)}
              viewBox="0 0 10 10"
              refX={refX}
              refY="5"
              markerWidth="9"
              markerHeight="9"
              markerUnits="userSpaceOnUse"
              orient="auto"
            >
              <path d="M0 0.5 L10 5 L0 9.5 Z" fill={SIGNAL_META[signal].color} />
            </marker>
          ))}
        </defs>
      </svg>
    </ViewportPortal>
  )
}
